export function ActivityMarker({ x, y, color, index }) {
  // Size decreases for older activities
  const size = Math.max(2, 4 - index * 0.5);
  const opacity = Math.max(0.3, 1 - index * 0.15);
  
  return (
    <g>
      {/* Glow */}
      <circle
        cx={x}
        cy={y}
        r={size + 2}
        fill={color}
        opacity={opacity * 0.3}
      />
      {/* Marker */}
      <circle
        cx={x}
        cy={y}
        r={size}
        fill={color}
        opacity={opacity}
        className="transition-all duration-300"
      />
    </g>
  );
}

export default ActivityMarker;
